<!-- XXXX签名 -->
<template>
  <SignCanvas
    ref="SignCanvasRef"
    :signName="nameList[nameIndex]"
    @sureHandler="sureSignHandler"
  />
</template>

<script>
import { fileUpload, insertPic } from "@/api";
export default {
  name: "BloodRegisterSign",
  components: {},

  data() {
    return {
      // ...
      actionId: "",
      codeTime: "",
      uploadFlag: true,
      inputData: {}, // 该数据中 cxmjView 为需要签名的人员姓名
      nameIndex: 0, // 当前签名为第几个人签名
      signFileList: [], // 签名图片列表
    };
  },

  computed: {
    nameList() {
      return this.inputData.cxmjView ? this.inputData.cxmjView.split(",") : []; // 需要有多个签名
    },
  },

  watch: {},

  created() {
    var url = window.location.href; //获取当前url
    console.log(url);
    var dz_url = url.split("#")[0]; //获取#/之前的字符串
    console.log(dz_url);
    var cs = dz_url.split("?")[1];
    console.log(cs); //获取?之后的参数字符串
    var cs_arr = cs.split("&"); //参数字符串分割为数组
    var cs = {};
    for (var i = 0; i < cs_arr.length; i++) {
      //遍历数组，拿到json对象
      cs[cs_arr[i].split("=")[0]] = cs_arr[i].split("=")[1];
    }
    //这样就拿到了参数中的数据

    console.log(cs.actionId);
    this.actionId = cs.actionId;
    if (cs.platform != undefined && cs.platform == "queue") {
      var that = this;
      that.uploadFlag = true;
    } else {
      var that = this;
      that.uploadFlag = true;
      console.log(new Date().getTime());

      that.codeTime = 60 - (new Date().getTime() - cs.time) / 1000;
      console.log(that.codeTime);
      var timer = setInterval(() => {
        if (that.codeTime <= 0) {
          that.uploadFlag = false;
          clearInterval(timer);
        } else {
          that.codeTime--;
          console.log(that.codeTime);
        }
      }, 1000);
    }

    this.inputData = JSON.parse(this.$route.query.inputData || "{}");
    // ...
  },

  methods: {
    GetUrlParam(paraName) {
      var url = document.location.toString();
      var arrObj = url.split("?");
      if (arrObj.length > 1) {
        var arrPara = arrObj[1].split("&");
        var arr;
        for (var i = 0; i < arrPara.length; i++) {
          arr = arrPara[i].split("=");

          if (arr != null && arr[0] == paraName) {
            return arr[1];
          }
        }
        return "";
      } else {
        return "";
      }
    },
    sureSignHandler(data) {
      var that = this;
      console.log(that.uploadFlag);
      if (!this.uploadFlag) {
        console.log("二维码已过期，请重新刷新并扫码");
        let instance = that.$toast({
          message: "二维码已过期，请重新刷新并扫码",
          className: "toastClass",
          position: "bottom",
          // iconClass: "icon icon-success",
          duration: 2000,
        });
        return;
      }
      const formData = new FormData(); // 下面有备注
      formData.append("file", data);
      fileUpload(formData).then((res) => {
        console.log(res);
        if (res.data.success) {
          let instance = that.$toast({
            message: "提交成功",
            className: "toastClass",
            position: "bottom",
            // iconClass: "icon icon-success",
            duration: 2000,
          });
          that.submitHandler(res.data.pic_url);
        } else {
          let instance = that.$toast({
            message: "提交失败",
            className: "toastClass",
            position: "bottom",
            // iconClass: "icon icon-success",
            duration: 2000,
          });
        }
      });
    },

    submitHandler(picUrl) {
      var that = this;
      var url = window.location.href; //获取当前url
      console.log(url);
      var dz_url = url.split("#")[0]; //获取#/之前的字符串
      console.log(dz_url);
      var cs = dz_url.split("?")[1];
      console.log(cs); //获取?之后的参数字符串
      var cs_arr = cs.split("&"); //参数字符串分割为数组
      var cs = {};
      for (var i = 0; i < cs_arr.length; i++) {
        //遍历数组，拿到json对象
        cs[cs_arr[i].split("=")[0]] = cs_arr[i].split("=")[1];
      }
      let obj = {
        actionId: this.actionId,
        picUrl: picUrl,
        picType: 41, //文件类型
        fileName: "signPic", //文件名
      };
			if (cs.platform == "queueDoctor") {
				obj.picType = 42; //医生端的队列签字
			}
      if (cs.platform == "edc") {
				obj.picType = 202; //edc表单签名
			}
      insertPic(obj).then((res) => {
        if (res.data.status) {
          let instance = that.$toast({
            message: "提交成功",
            position: "bottom",
            className: "toastClass",
            // iconClass: "icon icon-success",
            duration: 2000,
          });

          if (cs.platform != undefined && cs.platform == "queue") {
            if (cs.evn != undefined && cs.evn == "dev") {
              window.location.href =
                "https://ky.docteams.cn/devpatient/#/queue/applyGroup?studyId=" +
                cs.studyId;
            } else {
              window.location.href =
                "https://ky.docteams.cn/patient/#/queue/applyGroup?studyId=" +
                cs.studyId;
            }
          } else if (cs.platform != undefined && cs.platform == "queueDoctor") {
            if (cs.evn != undefined && cs.evn == "dev") {
              window.location.href =
                "https://ky.docteams.cn/devpatient/#/doctorSignSuccess?studyId=" +
                cs.studyId +
                "&actionId=" +
                this.actionId + "&patientGroupId=" + cs.patientGroupId + "&teamsId=" + cs.teamsId;
            } else {
              window.location.href =
                "https://ky.docteams.cn/patient/#/doctorSignSuccess?studyId=" +
                cs.studyId +
                "&actionId=" +
                this.actionId + "&patientGroupId=" + cs.patientGroupId + "&teamsId=" + cs.teamsId;
            }
          } else if (cs.platform != undefined && cs.platform == "edc") {
            that.$router.push("success");
          } else {
            that.$router.push("success");
          }
        } else {
          that.$toast({
            message: "提交失败",
            position: "bottom",
            className: "toastClass",
            duration: 2000,
          });
        }
      });
    },
  },
};
</script>

<style lang="scss">
.toastClass {
  transform: rotate(90deg) translateX(-360px) translateY(150px) !important;
}
</style>



// WEBPACK FOOTER //
// index.vue?186fb4d1